import { Link } from 'react-router-dom';

const footerLinks = {
  浏览导航: [
    { label: '热门推荐', to: '/category/hot' },
    { label: '精选电影', to: '/category/movie' },
    { label: '热门剧集', to: '/category/drama' },
    { label: '动漫动画', to: '/category/anime' },
    { label: '综艺娱乐', to: '/category/variety' },
    { label: '纪录纪实', to: '/category/documentary' },
  ],
  关于我们: [
    { label: '品牌介绍', to: '/about' },
    { label: '联系方式', to: '/about' },
    { label: '常见问题', to: '/about' },
  ],
  帮助支持: [
    { label: '用户协议', to: '/about' },
    { label: '隐私政策', to: '/about' },
    { label: '版权声明', to: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-primary-500">
                91<span className="text-foreground-950">在线视频</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              精选高分热门影视内容<br />
              高清在线观看不缓冲<br />
              为您提供最优质的观影体验
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-700 mb-4">{title}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 91在线视频. 保留所有权利.
          </p>
          <p className="text-xs text-foreground-400">
            91精品视频在线 | 91精品视频在线播放 | 高清在线观看
          </p>
        </div>
      </div>
    </footer>
  );
}